<template>
  <div class="content">
    <div class="build-CURD">
      <div class="build-bar" style="padding:0 1vh;display:flex;align-items: center;">
        <!-- -->
        <span>视频名称：</span>
        <div style="width:10vw;">
          <el-input placeholder="请输入视频名称" v-model="search.videoName"></el-input>
        </div>
        <span style="margin-left:1vh;">项目名称：</span>
        <div style="width:10vw;">
          <el-input placeholder="请输入项目名称" v-model="search.projectName"></el-input>
        </div>
        <el-button type="primary" icon="el-icon-search" @click="doFilter" style="margin-left:2vh;">查询</el-button>
      </div>
      <div class="build-table">
        <el-table
          :default-sort="{prop: 'date', order: 'descending'}"
          :data="tableDataEnd"
          style="width: 100%;"
        >
          <template slot="empty">
            <p>{{dataText}}</p>
          </template>
          <el-table-column label="序号" width="80">
            <template slot-scope="scope">
              <span>{{ scope.row.index }}</span>
            </template>
          </el-table-column>
          <el-table-column label="视频名称">
            <template slot-scope="scope">
              <a>{{ scope.row.videoName }}</a>
            </template>
          </el-table-column>
          <el-table-column label="播放时长">
            <template slot-scope="scope">
              <span>{{ scope.row.videoLength }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="企业">
            <template slot-scope="scope">
              <span>{{ scope.row.enterpriseName }}</span>
            </template>
          </el-table-column> -->
          <el-table-column label="使用项目">
            <template slot-scope="scope">
              <span>{{ scope.row.projectName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="时间">
            <template slot-scope="scope">
              <span>{{ scope.row.createDate }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 表单列表 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[3, 5, 10]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalItems"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util.js'
import base from '../../untils/base'
var _index
export default {
  data() {
    return {
      search:{
        entId:'',
        videoName:'',
        projectName:'',
      },
      tableDataName: '',
      tableDataEnd: [],
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,
      types: [],
      dataText: '数据加载中...',
      videoId: '',
      groupId:'',
    }
  },
  mounted() {
    this.groupId = util.session.get('groupId')
    this.getData()
  },
  methods: {
    //查询
    doFilter() {
      this.currentPage = 1
      this.getData()
    },

    //监听分页一页展示数量改变
    handleSizeChange(val) {
      this.pageSize = val
      this.handleCurrentChange(this.currentPage)
    },
    //监听当前页面改变
    handleCurrentChange(val) {
      this.currentPage = val
      this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
      this.getData()
    },
    // 获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.pageSize = this.pageSize
      this.search.pageNum = this.currentPage
      myHttp.getExamVideoProjectList(this.search).then(function(resp) {
          if (resp.data.code == '200') {
            //console.log(resp)
            var list = resp.data.data.pageInfo.list || []
            for (var i = 0; i < list.length; i++) {
              list[i].index =
                that.pageSize * (parseInt(that.currentPage) - 1) + (i + 1)
            }
            that.tableDataEnd = list
            that.totalItems = resp.data.data.pageInfo.total || 0
            if (that.tableDataEnd.length == 0) {
              that.dataText = '暂无数据'
            }
          } else {
            that.$message.error(resp.data.msg)
            that.dataText = '暂无数据'
          }
        },
        function() {}
      )
    },
    
    // 删除数据
    handleDelete(index, row) {
      var that = this
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
          myHttp.cancelDistributeVideo({
              videoGroupId: row.videoEntId
          }).then(function(resp) {
              if (resp.data.code == '200') {
                that.$message.success('删除成功')
                that.getData()
              } else {
                that.$message.error(resp.data.msg)
              }
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    
    //根据id过滤出name
    getNameById(id) {
      var result = ''
      for (var i = 0; i < this.projects.length; i++) {
        if (id == this.projects[i].id) {
          result = this.projects[i].name
        }
      }
      return result
    },
    
  }
}
</script>
<style>
@import '../../assets/css/common.css';
</style>
<style scoped>
* {
  box-sizing: border-box;
}
.content {
  height: 100%;
  background: #fff;
}
.build-CURD {
  width: 100%;
  height: 100%;
  position: relative;
}
.build-table {
  height: calc(100% - 160px);
}
.el-table >>> .cell {
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.build-bar >>> .btnLef {
  margin-left: 200px;
}

.el-form >>> .upload-demo {
  width: 220px;
  margin-bottom: 20px;
  margin-left: 100px;
}

.add-form >>> .el-upload-dragger {
  width: 100%;
  height: 100px;
}

.build-bar .add-user >>> span {
  text-align: center;
  margin-left: 2px;
}

.add-form .el-form-item {
  width: 80%;
}

.build-table >>> .el-dialog {
  padding-left: 0;
}
.video-avatar {
  width: 200px;
  height: 150px;
}
</style>
<style>
.el-select .el-input {
  width: 100%;
}
</style>